export default "__VITE_ASSET__3659b7cf__"